import { useCallback, useMemo } from 'react';
import { useMaterialUIController } from 'context';
import { showAlert as showAlertBase } from './showAlert';
import showConfirmDelete from './showConfirmDelete';
import showConfirmCascade, { CascadeChoice } from './showConfirmCascade';

/// Funções estáveis: recriadas a cada render, quem as usa em useCallback/useEffect entra em laço.
export const useAlert = () => {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    const showAlert = useCallback(
        (
            message: string,
            type: 'success' | 'error' | 'warning' | 'info' | 'question',
            timer?: number
        ) => {
            showAlertBase(message, type, timer, darkMode);
        },
        [darkMode]
    );

    const alertDelete = useCallback(
        (id: string, deleteFunction: (id: string) => void, name?: string, detail?: string) => {
            showConfirmDelete(id, deleteFunction, name, detail, darkMode);
        },
        [darkMode]
    );

    const alertCascade = useCallback(
        (message: string): Promise<CascadeChoice> => showConfirmCascade(message, darkMode),
        [darkMode]
    );

    return useMemo(
        () => ({ showAlert, alertDelete, alertCascade }),
        [showAlert, alertDelete, alertCascade]
    );
};
